{% block sw_category_view_tabs_seo %}

    {% parent %}

    <sw-tabs-item
        v-show="isPage"
        :route="{ name: 'sw.category.detail.topdata-product-boxes' }"
        :title="$tc('TopdataProductBoxesSW6.productBoxSettings.tabTitle')"
    >{{ $tc('TopdataProductBoxesSW6.productBoxSettings.tabTitle') }}</sw-tabs-item>

{% endblock %}